import React, { Component } from 'react'
import './index.less'
import DateTimePicker from 'react-vant/es/datetime-picker/DatetimePicker.js'
import Picker from 'react-vant/es/picker'
import 'react-vant/es/styles';

export default class extends Component {
  state = {
    minDate: 0,
    datePickerShow: false,
    hourPickerShow: false,
    hourValue: 1,
    startDate: "",
    imagePath: "",
  }

  componentDidMount() {
    this.initTime()
  }

  formatTxt(t, v) {
    if (t == "year") {
      t = "年"
    }
    if (t == "month") {
      t = "月"
    }
    if (t == "day") {
      t = "日"
    }
    if (t == "hour") {
      t = "时"
    }
    if (t == "minute") {
      t = "分"
    }
    return v + t
  }

  initTime() {
    // 获取当前时间的时间戳
    var timestamp = Date.now();
    // 创建一个新的Date对象，并设置时间戳
    var date = new Date(timestamp);
    // 设置时区偏移量（以分钟为单位）
    var timezoneOffset = 0; // 例如，中国标准时间（CST）为UTC+8，所以偏移量为8小时，即8 * 60 = 480分钟
    // 根据时区偏移量调整时间
    date.setMinutes(date.getMinutes() + timezoneOffset);

    this.setState({
      startDate: date,
      minDate: date
    })

    // 获取调整后的时间的各个部分
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // 月份从0开始，所以要加1
    var day = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    // 输出时间
    console.log(year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds);
  }

  handleDateConfirm(value) {
    console.log(new Date(value).getTime())
    this.setState({
      startDate: new Date(value),
      datePickerShow: false
    })
  }

  handleDateCancel() {
    this.setState({
      datePickerShow: false
    })
  }

  handleHourConfirm(value) {
    this.setState({
      hourValue: value,
      hourPickerShow: false
    })
  }

  handleHourCancel() {
    this.setState({
      hourPickerShow: false
    })
  }



  async onImgFileFn(e) {
    e.preventDefault()
    console.log(e.target.files)
    //获取图片文件，图片类型，图片大小
    const file = e.target.files[0]
    const type = file && file.type
    const size = file && file.size
    const regularType = ['image/png', 'image/jpg', 'image/jpeg']
    //图片类型限制
    if (regularType.indexOf(type.toLowerCase()) === -1) {
      alert('Only supports PNG or JPG images!')
      return false
    }
    //图片大小限制
    if (size && size > 5242880) {
      // 5 * 1024 * 1024，size的单位是字节
      alert('The image size should less than 5M!')
      return false
    }
    //图片文件转成base64格式
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      this.setState({
        imagePath: reader.result
      })
    }
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    this.setState({
      formData: formData
    })
    e.target.value = '' // 清空上次图片数据，保证可以选择同一张图片
  }

  clearImg(nu, e) {
    e.stopPropagation()
    this.setState({
      imgUrl: "",
      formData: "",
      imagePath: "",
      picList: []
    })
  }

  render() {
    const columns = [
      { text: '1h', value: 1 },
      { text: '2h', value: 2 },
      { text: '3h', value: 3 },
    ]
    return (
      <div className="asd">
        <div className="btn" onClick={() => { this.setState({ datePickerShow: true }); this.initTime() }}>开启1</div>
        <div className="btn" onClick={() => { this.setState({ hourPickerShow: true }) }}>开启2</div>

        <div
          className="mask"
          onClick={() => {
            this.setState({
              datePickerShow: false,
              hourPickerShow: false,
            })
          }}
          style={{ display: `${this.state.datePickerShow || this.state.hourPickerShow ? "block" : "none"}` }}></div>

        <div className="duration" style={{
          bottom: `${this.state.hourPickerShow ? "0" : "-10rem"}`
        }}>
          <Picker
            visibleItemCount={3}
            // placeholder={false}
            // showToolbar={false}
            // onChange={(val, selectRow, index) => {
            //   console.log('选中项: ', val)
            //   console.log('选中项: ', index)
            //   console.log('选中项: ', selectRow)
            // }}
            title='持续时间'
            columns={columns}
            itemHeight={"1rem"}
            onConfirm={(value) => this.handleHourConfirm(value)}
            onCancel={() => this.handleHourCancel()}
          />
        </div>

        <div className="time" style={{
          bottom: `${this.state.datePickerShow ? "0" : "-10rem"}`
        }}>
          <DateTimePicker
            type='datetime'
            itemHeight={"0.8rem"}
            minDate={new Date(this.state.minDate)}
            // maxDate={new Date("2023/12/31")}
            value={new Date(this.state.startDate)}
            formatter={(t, v) => this.formatTxt(t, v)}
            onConfirm={(value) => this.handleDateConfirm(value)}
            onCancel={() => this.handleDateCancel()}
            cancelButtonText={"取消"}
            confirmButtonText={"确定"}
            title={"开始时间"}
          />
        </div>

        <div className="select-img-input-outer">
          <label className='select-img-input' htmlFor="upload" onClick={() => { this.androidUpload() }}>
          </label>
          <div
            className='display-img'
            style={{ display: `${this.state.imagePath != "" ? "block" : "none"}` }}>
            <img
              style={{ display: `${this.state.imagePath ? "block" : "none"}` }}
              className='del'
              onClick={(e) => { this.clearImg(1, e) }}
              src="/img/activity/ladies/del.png" />
            <img
              style={{ display: `${this.state.imagePath ? "block" : "none"}` }}
              className='imagePath'
              onClick={(e) => { this.handleShowPic(e, true) }}
              src={this.state.imagePath} />
          </div>
        </div>
        <input
          id='upload'
          className='upload'
          onChange={(event) => this.onImgFileFn(event)}
          type='file'
          name='fileSelect'
          accept='image/*'
          multiple="mutiple"
        />
      </div >
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/test2/index.js